/* eslint-disable react/jsx-closing-tag-location, no-nested-ternary, object-property-newline, react/jsx-one-expression-per-line, operator-linebreak, indent */
/** Farm — dalalar ro'yxati (web S1). Chegara chizish mobil ilovada;
 * webda dala ma'lumotlari + qo'lda maydon kiritiladi. */
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Layout from '../../components/Layout'
import Loader from '../../components/common/Loader'
import FarmModal from './FarmModal'
import { farmRequest, fmtNum, useFarmList } from './api'

export default function FarmFields() {
    const [search, setSearch] = useState('')
    const [showArchived, setShowArchived] = useState(false)
    const [editing, setEditing] = useState(null) // null | {} (yangi) | field
    const fields = useFarmList('fields/', {
        search: search || undefined,
        includeArchived: showArchived ? 1 : undefined,
    }, [search, showArchived])
    const categories = useFarmList('categories/', {}, [])

    async function toggleArchive(field) {
        // eslint-disable-next-line no-alert
        if (!window.confirm(field.isArchived
            ? 'Dala arxivdan chiqarilsinmi?'
            : 'Dala arxivlansinmi? (ma‘lumotlar saqlanadi)')) return
        await farmRequest({
            url: `fields/${field.id}/`,
            method: 'PATCH',
            data: { isArchived: !field.isArchived },
        })
        fields.reload()
    }

    return (
        <Layout>
            <div className="is-flex is-justify-content-space-between is-align-items-center mb-4">
                <h1 className="title is-4 mb-0">Dala boshqaruvi</h1>
                <div className="is-flex is-align-items-center" style={{ gap: 12 }}>
                    <Link to="/farm/map" className="button is-light">
                        <i className="icon ion-md-map mr-1" /> Xarita
                    </Link>
                    <Link to="/farm/reports" className="button is-light">
                        <i className="icon ion-md-stats mr-1" /> Hisobotlar
                    </Link>
                    <Link to="/farm/settings" className="button is-light">
                        <i className="icon ion-md-settings mr-1" /> Sozlamalar
                    </Link>
                    <button type="button" className="button is-link"
                        onClick={() => setEditing({})}>
                        <i className="icon ion-md-add mr-1" /> Yangi dala
                    </button>
                </div>
            </div>

            <div className="is-flex is-align-items-center mb-3" style={{ gap: 16 }}>
                <input className="input" style={{ maxWidth: 320 }}
                    placeholder="Dala nomi bo‘yicha qidirish..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)} />
                <label className="checkbox">
                    <input type="checkbox" checked={showArchived}
                        onChange={(e) => setShowArchived(e.target.checked)} />
                    {' '}Arxivlanganlar ham
                </label>
            </div>

            <div className="box">
                {fields.loading ? <Loader center /> : (
                    <table className="table is-fullwidth is-hoverable">
                        <thead>
                            <tr>
                                <th>Nomi</th>
                                <th>Kategoriya</th>
                                <th className="has-text-right">Maydon (ga)</th>
                                <th>Joriy ekin</th>
                                <th>Holat</th>
                                <th style={{ width: 140 }} />
                            </tr>
                        </thead>
                        <tbody>
                            {fields.items.length === 0 && (
                                <tr><td colSpan={6} className="has-text-centered has-text-grey py-5">
                                    Hozircha dala yo‘q. «Yangi dala» bilan boshlang.
                                    Chegara chizish — mobil ilovada.
                                </td></tr>
                            )}
                            {fields.items.map((f) => (
                                <tr key={f.id}>
                                    <td>
                                        <Link to={`/farm/fields/${f.id}`}><b>{f.name}</b></Link>
                                        {f.locationNote ? (
                                            <span className="has-text-grey is-size-7"> — {f.locationNote}</span>
                                        ) : null}
                                    </td>
                                    <td>
                                        <span className="tag" style={{
                                            backgroundColor: f.categoryColor || '#eee',
                                            color: f.categoryColor ? '#fff' : undefined,
                                        }}>{f.categoryName}</span>
                                    </td>
                                    <td className="has-text-right">{fmtNum(f.areaHa, 2)}</td>
                                    <td>{f.currentCrop || <span className="has-text-grey">—</span>}</td>
                                    <td>{f.isArchived
                                        ? <span className="tag is-warning is-light">arxivda</span>
                                        : <span className="tag is-success is-light">faol</span>}</td>
                                    <td className="has-text-right">
                                        <button type="button" className="button is-small is-light mr-1"
                                            title="Tahrirlash" onClick={() => setEditing(f)}>
                                            <i className="icon ion-md-create" />
                                        </button>
                                        <button type="button" className="button is-small is-light"
                                            title={f.isArchived ? 'Arxivdan chiqarish' : 'Arxivlash'}
                                            onClick={() => toggleArchive(f)}>
                                            <i className={`icon ${f.isArchived ? 'ion-md-refresh' : 'ion-md-archive'}`} />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>

            <FieldFormModal
                key={editing ? editing.id || 'new' : 'closed'}
                field={editing}
                categories={categories.items}
                onSaved={() => { setEditing(null); fields.reload(); categories.reload() }}
                onClose={() => setEditing(null)} />
        </Layout>
    )
}

function FieldFormModal({ field, categories, onSaved, onClose }) {
    const isOpen = field !== null
    const existing = field && field.id ? field : null
    const [name, setName] = useState(existing ? existing.name : '')
    const [categoryId, setCategoryId] = useState(existing ? existing.category : '')
    const [newCategory, setNewCategory] = useState('')
    const [areaHa, setAreaHa] = useState(existing && existing.areaHa ? existing.areaHa : '')
    const [locationNote, setLocationNote] = useState(existing ? existing.locationNote : '')
    const [saving, setSaving] = useState(false)
    const [error, setError] = useState('')

    async function save(e) {
        e.preventDefault()
        setSaving(true)
        setError('')
        try {
            let catId = categoryId
            if (!catId && newCategory.trim()) {
                const cat = await farmRequest({
                    url: 'categories/', method: 'POST', data: { name: newCategory.trim() },
                })
                catId = cat.id
            }
            if (!name.trim() || !catId) {
                setError('Nomi va kategoriya majburiy.')
                setSaving(false)
                return
            }
            const data = {
                name: name.trim(),
                category: catId,
                locationNote: locationNote.trim(),
            }
            // Chegara chizilgan bo'lsa maydonga tegmaymiz (server hisoblagan)
            if (!(existing && existing.boundary)) data.areaHa = areaHa || '0'
            await farmRequest(existing
                ? { url: `fields/${existing.id}/`, method: 'PATCH', data }
                : { url: 'fields/', method: 'POST', data })
            onSaved()
        } catch (err) {
            const detail = err.response && err.response.data
            setError(typeof detail === 'object'
                ? JSON.stringify(detail) : 'Saqlashda xato — qayta urinib ko‘ring.')
        } finally {
            setSaving(false)
        }
    }

    return (
        <FarmModal title={existing ? 'Dalani tahrirlash' : 'Yangi dala'}
            isOpen={isOpen} onClose={onClose}>
            <form onSubmit={save}>
                <div className="field">
                    <label className="label">Nomi *</label>
                    <input className="input" value={name}
                        onChange={(e) => setName(e.target.value)} />
                </div>
                <div className="field">
                    <label className="label">Kategoriya *</label>
                    <div className="select is-fullwidth">
                        <select value={categoryId}
                            onChange={(e) => setCategoryId(e.target.value)}>
                            <option value="">— tanlang yoki pastda yangisini yozing —</option>
                            {categories.map((c) => (
                                <option key={c.id} value={c.id}>{c.name}</option>
                            ))}
                        </select>
                    </div>
                    {!categoryId && (
                        <input className="input mt-2" placeholder="Yangi kategoriya nomi"
                            value={newCategory}
                            onChange={(e) => setNewCategory(e.target.value)} />
                    )}
                </div>
                <div className="field">
                    <label className="label">Maydon (gektar)</label>
                    <input className="input" type="number" step="0.01" min="0"
                        value={areaHa}
                        disabled={!!(existing && existing.boundary)}
                        onChange={(e) => setAreaHa(e.target.value)} />
                    {existing && existing.boundary ? (
                        <p className="help">Chegara xaritada chizilgan — maydon avtomatik.</p>
                    ) : (
                        <p className="help">Chegara chizish mobil ilovada; webda maydon qo‘lda kiritiladi.</p>
                    )}
                </div>
                <div className="field">
                    <label className="label">Joylashuv izohi</label>
                    <input className="input" value={locationNote}
                        onChange={(e) => setLocationNote(e.target.value)} />
                </div>
                {error && <p className="has-text-danger is-size-7 mb-2">{error}</p>}
                <button type="submit" className={`button is-link is-fullwidth ${saving ? 'is-loading' : ''}`}>
                    Saqlash
                </button>
            </form>
        </FarmModal>
    )
}
